import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["the-10-percent-rule"]!;

export function Body() {
  return (
    <>
      <p>
        "Never increase your weekly distance by more than 10 percent" is one of the best-known
        rules in running. Two studies of new runners tested whether it prevents injuries.
      </p>

      <h2>What the researchers did</h2>
      <p>
        In the Netherlands, 532 new runners preparing for a 6.7 km event were randomly given one
        of two programmes. One was a standard 8-week programme. The other took 13 weeks and
        followed the 10 percent rule.
      </p>
      <p>
        In Denmark, 874 new runners were given a GPS watch and followed for a year while they
        trained on their own. The researchers grouped each run by how much the weekly distance
        had increased: less than 10 percent, 10 to 30 percent, or more than 30 percent.
      </p>

      <h2>What they found</h2>
      <p>
        In the Dutch trial, the slower 10 percent programme made no difference. About 21 percent
        were injured in the 13-week programme and 20 percent in the 8-week programme.
      </p>
      <p>
        In the Danish study, the overall injury rate did not differ between the three groups.
        But runners who increased their weekly distance by more than 30 percent seemed more
        likely to get injuries typically linked to running distance, such as runner's knee, shin
        splints and pain on the outside of the knee.
      </p>

      <h2>What it means for you</h2>
      <p>
        The 10 percent rule is not a magic limit. Increasing a little more in a week is not
        dangerous in itself, and following the rule strictly doesn't protect you. Large jumps,
        such as a third more running from one week to the next, are worth avoiding, especially
        when you are new to running.
      </p>
      <p>
        Each run matters too. A single run that is much longer than you are used to can be a
        bigger risk than the weekly total.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        Both studies included new runners, not experienced runners. The Danish study was
        exploratory, and its main finding was close to, but not, statistically significant.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training doesn't use a fixed weekly percentage. It looks at each planned run against
        your recent training and flags long runs that are much longer than your longest run in
        the past 30 days.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Buist et al. (2008), No effect of a graded training program on the number of
          running-related injuries in novice runners: a randomized controlled trial.{" "}
          <a href="https://doi.org/10.1177/0363546507307505">American Journal of Sports Medicine</a>.
        </li>
        <li>
          Nielsen et al. (2014), Excessive progression in weekly running distance and risk of
          running-related injuries: an association which varies according to type of injury.{" "}
          <a href="https://doi.org/10.2519/jospt.2014.5164">Journal of Orthopaedic & Sports Physical Therapy</a>.
        </li>
      </ul>
    </>
  );
}
